import { ClientActionTypes } from '../client.action-types'

const initialStates = {
    makes: [],
    models: [],
    safeTypes: [],
    safeSubTypes: [],
    components: [],
    contactCategories: [],
    contactTopics: [],
    issues: [],
    safeMakes: [],
    safeModels: [],
    storageTypes: [],
    classifications: [],
}

const ClassificationReducer = (state = initialStates, action: any) => {
    switch (action.type) {
        case ClientActionTypes.GET_MAKES:
            return { ...state, makes: action.payload }
        case ClientActionTypes.GET_MODELS:
            return { ...state, models: action.payload }
        case ClientActionTypes.GET_SAFE_TYPES:
            return { ...state, safeTypes: action.payload }
        case ClientActionTypes.GET_SAFE_SUB_TYPES:
            return { ...state, safeSubTypes: action.payload }
        case ClientActionTypes.GET_COMPONENTS:
            return { ...state, components: action.payload }
        case ClientActionTypes.GET_CONTACT_CATEGORIES:
            return { ...state, contactCategories: action.payload }
        case ClientActionTypes.GET_CONTACT_TOPICS:
            return { ...state, contactTopics: action.payload }
        case ClientActionTypes.GET_ISSUE:
            return { ...state, issues: action.payload }
        case ClientActionTypes.GET_SAFE_MAKE:
            return { ...state, safeMakes: action.payload }
        case ClientActionTypes.GET_SAFE_MODEL:
            return { ...state, safeModels: action.payload }
        case ClientActionTypes.GET_STORAGE_TYPES:
            return { ...state, storageTypes: action.payload }
        case ClientActionTypes.GET_CLASSIFICATIONS_SUGGESTION:
            return { ...state, classifications: action.payload }
        default:
            return { ...state }
    }
}

export default ClassificationReducer
